import React, {useEffect} from "react";
import "./comment.scss";
import * as reduxSelectors from "components/store/application.reducers.js";
import { useSelector } from "react-redux";
import { COMMENTS_INPUT_MAX_LENGTH } from "utils/constants";
import { CommentInputProps } from "types/comments";
import { launchDarkly } from "utils/launchDarkly";

const Comment =  React.forwardRef((props: CommentInputProps, ref) => {

    //remove this when FF useDraftComments is released -->>
    const useDraftComments = launchDarkly.userClient && launchDarkly.userClient.variation("fe-draft-comments", false);
    const taskComment = useSelector(useDraftComments ? reduxSelectors.getTaskDraftCommentText : reduxSelectors.getTaskUnsavedComment);
    const allowExtraComments = useSelector(reduxSelectors.getAllowExtraComments);
    const [value, setValue] = React.useState( !props.hideInitialValue && allowExtraComments ? taskComment : props.value);
    //<<--
    //uncomment next line FF useDraftComments is released
    // const [value, setValue] = React.useState(props.value);
    const inputLimit = props.inputLimit != null ? props.inputLimit : COMMENTS_INPUT_MAX_LENGTH;

    useEffect(() => {
        if(value !== props.value)
            changeValue(props.value);
    },[props.value]);

    //remove this when FF useDraftComments is released -->
    useEffect(() => {
        changeValue(value);
    }, []);
    //<<--

    const onChange = function(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const value = event.target.value;
        if (inputLimit <= 0 || value.length <= inputLimit) {
            changeValue(value);
        }
    };

    const changeValue = function(newValue: string) {
        setValue(newValue);
        props.propagateValue(newValue);
    }

    const charsLeft = function() {
        return inputLimit > 0 ?
            <span className="text-disabled col-md-12 px-0">
                    {props.translate("input.comment.charsLeft", (inputLimit - (value ? value.length : 0)))}
                </span>
            : "";
    }

    return (
        <div>
            <textarea
                // @ts-ignore
                ref={ref}
                tabIndex={props.tabIndex}
                className={props.className || "col-xs-12 comment-box-textarea ast_comment_input"}
                placeholder={props.inputHint}
                value={value || ''}
                onChange={onChange} />
            {charsLeft()}
        </div>

    );
});

export default Comment;